// extracted by mini-css-extract-plugin
export default {"toggle":"LanguageToggle_toggle__68WIW","option":"LanguageToggle_option__HAfYT","selected":"LanguageToggle_selected__lFxs9"};